import { render, staticRenderFns } from "./PayrollHistoryView.vue?vue&type=template&id=6d9613b4&scoped=true"
import script from "./PayrollHistoryView.vue?vue&type=script&lang=ts"
export * from "./PayrollHistoryView.vue?vue&type=script&lang=ts"
import style0 from "./PayrollHistoryView.vue?vue&type=style&index=0&id=6d9613b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9613b4",
  null
  
)

export default component.exports